<template>
  <div class="available-service-container">
    <template v-for="service in availableServiceDefinitions">
      <div :class="['service', { 'service--unavailable': !service.isAvailable }]" v-if="service.isVisible" :key="service.imageFileName">
        <img :src="require(`@/assets/${service.imageFileName}`)" />
        <i :class="getIconClass(service.isAvailable)"></i>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { AvailableServiceDefinition } from '@/models/available-service-definition'
import { GridOperator, OperatorLight, SubCity } from '@/models'
import { cmhService } from '@/services'
@Component({
  name: 'available-service-display'
})
export default class AvailableServiceDisplay extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: false }) public subCity!: SubCity | null
  //#endregion

  // Replace all with cmh-service after merge
  private get availableServiceDefinitions(): AvailableServiceDefinition[] {
    if (!this.subCity) {
      return []
    }

    return [
      new AvailableServiceDefinition(
        'Ores.svg',
        cmhService.isGridOperatorAvailable(this.subCity, GridOperator.ores)
      ),
      // RESA, if not available, has to be hidden, not disabled.
      new AvailableServiceDefinition(
        'Resa-Gas.svg',
        cmhService.isServiceAvailable(this.subCity, OperatorLight.resa),
        cmhService.isGridOperatorAvailable(this.subCity, GridOperator.resa)
      ),
      new AvailableServiceDefinition(
        'SWDE.svg',
        cmhService.isServiceAvailable(this.subCity, OperatorLight.swde)
      ),
      new AvailableServiceDefinition(
        'Proximus.svg',
        cmhService.isServiceAvailable(this.subCity, OperatorLight.proximus)
      ),
      new AvailableServiceDefinition(
        'Orange.svg',
        cmhService.isServiceAvailable(this.subCity, OperatorLight.orange)
      )
    ]
  }

  private getIconClass(isAvailable: boolean) {
    return isAvailable ? 'fa fa-check' : 'fa fa-times'
  }
}
</script>

<style scoped>
.available-service-container {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(52px, 152px);
  place-content: center;
  gap: 1.6rem;
}

.service {
  display: grid;
  place-content: center;
  gap: 1rem;
  padding: 4rem 1.6rem;
  color: #97bf0d;
  border: 1px solid #97bf0d;
  background: #fff;
  border-radius: 0.4rem;
}

.service>img {
  width: 7rem;
}

.service>img+i {
  text-align: center;
  font-size: 3.6rem;
}

.service--unavailable {
  color: #57666F;
  background: #DFE2DF;
  border-color: #DFE2DF;
}

@media screen and (min-width: 577px) {
  .available-service-container {
    margin: 32px auto 0;
    width: 560px;
  }
}

@media screen and (max-width: 576px) {
  .available-service-container {
    margin: 20px 20px 10px;
    min-width: 304px;
  }

  .service {
    padding: 1rem 0.8rem;
  }

  .service>img {
    width: 4.5rem;
  }

  .service>img+i {
    text-align: center;
    font-size: 2rem;
  }
}
</style>
